// Display font for "hero" numbers/titles — Playfair Display (from the design mockup),
// loaded in index.html. Falls back to a system serif if the web font is unavailable.
export const heroFontFamily = '"Playfair Display", Georgia, "Times New Roman", serif'
